import { render, staticRenderFns } from "./TherapyQuestionnaire.vue?vue&type=template&id=71deb50f"
import script from "./TherapyQuestionnaire.vue?vue&type=script&lang=js"
export * from "./TherapyQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./TherapyQuestionnaire.vue?vue&type=style&index=0&id=71deb50f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports